import {Component, forwardRef, inject, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR} from '@angular/forms';
import {Option} from '../../core/definitions/option-info';
import {FieldOptionsService} from '../../core/field-options.service';
import {FieldParameters} from '../../core/definitions/field-parameters';
import {ValueOptionService} from "../../core/value-option.service";

@Component({
    selector: 'app-edit-field-check-array',
    templateUrl: './edit-field-check-array.component.html',
    styleUrls: ['./edit-field-check-array.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => EditFieldCheckArrayComponent)
        }
    ],
    standalone: false
})
export class EditFieldCheckArrayComponent implements OnInit, ControlValueAccessor {
  // Injections
  private readonly fieldOptionsService: FieldOptionsService = inject(FieldOptionsService);
  private readonly valueOptionService: ValueOptionService = inject(ValueOptionService);

  @Input() fieldParameters: FieldParameters;
  @Input() formControl: FormControl;

  checkField: string;
  options: Option[];

  ngOnInit() {
    this.fieldParameters.object[this.fieldParameters.field.name] = [];
    this.fieldOptionsService.initOptions(this.fieldParameters).then(() => {
      this.getOptions()
    });
  }

  // No longer getting called continuously, so options with conditions will not update dynamically
  // The continuous updating has been sacrificed for performance reasons
  getOptions() {
    const options = this.fieldOptionsService.getOptions(this.fieldParameters);
    this.options = structuredClone(options);
    const valueOptions = this.valueOptionService.getValueOptionsForField(this.fieldParameters.field);
    this.checkField = valueOptions.inline_check_field;
    this.fieldParameters.object[this.fieldParameters.field.name] = this.options
  }

  toggleItem($event: any, item: Option) {
    $event.preventDefault();
    item[this.checkField] = !item[this.checkField];
    if (item['is_all_toggle']) {
      for (const option of this.options) {
        option[this.checkField] = item[this.checkField];
      }
    }
    this.formControl.markAsDirty();
  }

  registerOnChange(/*fn: any*/): void {
    // N/A
  }

  registerOnTouched(/*fn: any*/): void {
    // N/A
  }

  setDisabledState(/*isDisabled: boolean*/): void {
    // N/A
  }

  writeValue(/*obj: any*/): void {
    // N/A
  }

}
